import { render, staticRenderFns } from "./PracticeMembersPage.vue?vue&type=template&id=1437e468"
import script from "./PracticeMembersPage.vue?vue&type=script&lang=js"
export * from "./PracticeMembersPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports